import html2canvas from 'html2canvas';

export function sendInformationsToiFrame(url) {

  const frame = document.getElementById("pfqcn:phpconfig:ticketClient:feedback:iframe:frame");

  if (frame != null && frame) {
    sendUrlToiFrame(frame, url);
    sendCredentialsToiFrame(frame, url);
    sendHtmlToiFrame(frame, url);
    sendScreenshotToiFrame(frame, url);
  }
}

function sendUrlToiFrame(frame, url) {
    frame.contentWindow.postMessage({
        url: window.location.href
      }, url);
}

function sendCredentialsToiFrame(frame, url) {
    frame.contentWindow.postMessage({
        credentials: {
          username: "username",
          password: "password"
        }
      }, url);
}

function sendHtmlToiFrame(frame, url) {
    frame.contentWindow.postMessage({
        qaNote: document.body.innerHTML,
      }, url);
}

function sendScreenshotToiFrame(frame, url) {
    html2canvas(document.body).then((canvas) => {
        const imgData = canvas.toDataURL('img/png');
        frame.contentWindow.postMessage({
          screenshot: imgData,
        }, url);
      });
}